import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonText
} from '@ionic/react';

import classes from './style.module.scss';

const HelpPage = ({ match, history }) => {
  return (
    <IonPage id='feedback'>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>Help</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={classes.ionContent}>
        <IonText className={classes.title}>We're here to help you!</IonText>
        <div className={classes.contactInfo}>
          <IonText className={classes.caption}>Call</IonText>
          <IonText className={classes.mainInfo}>
            <a href='tel:432-477-0591'>432-477-0591</a>
          </IonText>
          <IonText className={classes.mainInfo}>
            <a href='tel:432-477-0591'>432-477-0591</a>
          </IonText>
        </div>
        <div className={classes.emailInfo}>
          <IonText className={classes.caption}>Emails</IonText>
          <IonText className={classes.mainInfo}>
            <a href='mailto:payment@barwisanywhere.com'>
              payment@barwisanywhere.com
            </a>
          </IonText>
          <IonText className={classes.mainInfo}>
            <a href='mailto:support@barwisanywhere.com'>
              support@barwisanywhere.com
            </a>
          </IonText>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HelpPage;
